const I = Object.freeze([10, 20]), e = 100, t = 10;
export {
  t as DEFAULT_PAGE_LIMIT,
  I as LIMIT_OPTIONS,
  e as MAX_PAGE_LIMIT
};
